import { fetchMarketResearch } from '@/api/business/marketResearch'
import { useQuery } from '@tanstack/react-query'

export const MarketResearchKeys = {
    all: ['marketresearch'] as const,
    lists: () => [...MarketResearchKeys.all, 'list'] as const,
    list: (page: number, perPage: number, filters: any) =>
        [...MarketResearchKeys.lists(), page, perPage, filters] as const,
    details: () => [...MarketResearchKeys.all, 'detail'] as const,
    detail: (params: string) => [...MarketResearchKeys.details(), params] as const,
}

export const useMarketResearchQuery = () => {
    return useQuery({
        queryFn: fetchMarketResearch,
        queryKey: MarketResearchKeys.lists(),
    })
}
